import { type FC, useState } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { Card } from '@/components/ui/card';
import { appConfig } from '@/config';
import { useMe } from '@/hooks/use-me';
import { LookerEnv } from '@/types/looker-env';
import { Label } from '@/ui/components/label';
import { Switch } from '@/ui/components/switch';

import { useFilter } from '../hooks/use-filter';

export const BenchmarkPage: FC = () => {
  const { filters, onFiltersChange } = useFilter();
  const [isInternalView, setIsInternalView] = useState(false);
  const me = useMe();

  // Only show toggle for internal users in staging environment
  const shouldShowToggle =
    me.isInternal && appConfig.defaultLookerEnv === LookerEnv.STAGING;

  return (
    <FullPageContent testId="benchmark-page">
      <Dashboard
        id={isInternalView ? 'assets_internal' : 'assets'}
        filters={filters}
        onFiltersChange={onFiltersChange}
      />

      {/* Floating toggle at bottom center - only visible for internal users in staging */}
      {shouldShowToggle && (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2">
          <Card className="border-gray-200 bg-white/95 px-4 py-3 shadow-lg backdrop-blur-sm">
            <div className="flex items-center gap-3">
              <Label
                htmlFor="internal-toggle"
                className="cursor-pointer text-sm font-medium text-gray-700"
              >
                Activate all features
              </Label>
              <Switch
                id="internal-toggle"
                value={isInternalView}
                onChange={setIsInternalView}
                aria-label="Toggle internal benchmark view"
              />
            </div>
          </Card>
        </div>
      )}
    </FullPageContent>
  );
};
